var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "live-back-sl",
  "use": "live-back-sl-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"live-back-sl\">\n    <path d=\"M5.738.18a.75.75 0 0 1 .147.969l-.066.09L2.381 5.25H15.25a.75.75 0 1 1 0 1.5H2.381l3.438 4.012a.75.75 0 0 1-.002.98l-.079.077a.75.75 0 0 1-.98-.002l-.077-.079-4.5-5.25-.011-.013A.75.75 0 0 1 0 6v-.034l.003-.038L0 6c0-.18.064-.346.17-.475l.01-.013 4.5-5.25A.75.75 0 0 1 5.739.18z\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id